exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-nl {\n  padding: 12px 4px 4px 4px;\n  text-transform: none;\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDataGrid/ubiLayoutDataGrid.component.scss
// module id = ../../../../../src/app/theme/components/ubiLayoutDataGrid/ubiLayoutDataGrid.component.scss
// module chunks = main